import React from 'react';

import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';

import { HeaderContainer, DrawerTitle } from './styles';

interface DrawerHeaderProps {
  title: string;
  onClose: () => void;
  titleRef?: React.Ref<HTMLHeadingElement>;
}

const DrawerHeader: React.FC<DrawerHeaderProps> = ({ title, onClose, titleRef }) => (
  <HeaderContainer>
    <DrawerTitle ref={titleRef} tabIndex={titleRef ? -1 : undefined}>
      {title}
    </DrawerTitle>
    <IconButton
      onClick={onClose}
      id="close-schedule-drawer"
      aria-label="Close"
      sx={{
        borderRadius: '50%',
        border: '1px solid #E0E0E0',
        width: '32px',
        height: '32px',
      }}
    >
      <Close sx={{ width: '18px', height: '18px' }} />
    </IconButton>
  </HeaderContainer>
);

export default DrawerHeader;
